import { jsxs as e, jsx as l } from "react/jsx-runtime";
const d = (a) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          fillRule: "evenodd",
          d: "M15 2a3 3 0 0 1 2.995 2.824L18 5v7.5a3 3 0 0 0-2.733 1.764A3 3 0 0 0 12.533 19c-.614.856-.75 2-.29 3H7a3 3 0 0 1-2.995-2.824L4 19V5a3 3 0 0 1 2.824-2.995L7 2zm-3 2h-2l-.117.007a1 1 0 0 0 0 1.986L10 6h2l.117-.007a1 1 0 0 0 0-1.986z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          fillRule: "evenodd",
          d: "M19.001 15.5a1 1 0 1 0-2 0v.672a3 3 0 0 0-.949.547l-.582-.335a1 1 0 1 0-1 1.732l.582.335a3 3 0 0 0 0 1.098l-.581.335a1 1 0 1 0 1 1.732l.581-.335a3 3 0 0 0 .95.547v.672a1 1 0 0 0 2 0v-.672c.345-.122.667-.307.949-.548l.582.336a1 1 0 1 0 1-1.732l-.582-.336a3 3 0 0 0 0-1.096l.581-.336a1 1 0 0 0-1-1.732l-.581.336a3 3 0 0 0-.95-.548zm-1.864 3-.018.03a1 1 0 0 0 1.743.979l.005-.009.005-.009a1 1 0 0 0 0-.982l-.005-.009-.005-.009a1 1 0 0 0-.86-.491 1 1 0 0 0-.865.5",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
export {
  d as default
};
